import { Popover, Slide } from '@mui/material';
import { TransitionProps as _TransitionProps } from '@mui/material/transitions';
import { motion } from 'framer-motion';
import { useMemo } from 'react';

export interface HideColumnsV2PopoverProps {
  isOpen: boolean;
  onClose: () => void;
  anchorEl: HTMLButtonElement | null;
  children: React.ReactNode;
}

const MotionPopover = motion.create(Popover);

const HideColumnsV2Popover = ({
  anchorEl,
  children,
  isOpen,
  onClose,
}: HideColumnsV2PopoverProps) => {
  const TransitionProps = useMemo(
    () =>
      ({
        direction: 'left',
      }) as _TransitionProps,
    [],
  );
  const transition = useMemo(() => ({ duration: 0.35, type: 'tween' as const }), []);
  const anchorOrigin = useMemo(
    () => ({
      vertical: 'bottom' as const,
      horizontal: 'center' as const,
    }),
    [],
  );

  return (
    <MotionPopover
      keepMounted
      open={isOpen}
      onClose={onClose}
      anchorEl={anchorEl}
      disableScrollLock={false}
      TransitionComponent={Slide}
      TransitionProps={TransitionProps}
      transition={transition}
      anchorOrigin={anchorOrigin}
    >
      {children}
    </MotionPopover>
  );
};

export default HideColumnsV2Popover;
